<template>
  <v-flex :class="'xs12' + (width ? ' md' + width : '')">
    <v-container fluid pa-0 px-0>
      <v-layout wrap :style="'margin: 10px;'">
        <v-flex xs12 class="panelTitle" v-if="title">{{ title }}</v-flex>
        <v-flex xs12>
          <v-container fluid pa-0 px-3>
            <v-layout wrap :style="innerStyle">
              <slot></slot>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
export default {
  name: 'PanelColumnX',
  props: ['width', 'title', 'first', 'last', 'innerStyle']
}
</script>

<style scoped>
  .panelTitle {
    font-weight: bold;
    font-size: 12pt;
    font-style: normal;
    color: #004d40;
    border-bottom: 1px solid #004d40;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PanelColumnX.vue